function headerSearch() {

    const input     = $('._js-header-search');
    const mobOpen   = $('._js-header-search-mob-open');
    const search    = input.parents('.header-search');
    const reset     = $('._js-header-reset');
    const mControls = $('.mobile-controls');

    input.on('focusin', function(){
        openSearch();
    });

    mobOpen.on('click', function(){
        openSearch();
    });

    function openSearch() {
      if ( !search.hasClass('_focused') ) {
        search.addClass('_focused');
        mControls.addClass('_z-index');
        setTimeout(function(){
          input.focus();
        }, 350);
      }
    }

    reset.on('click', function(){
        if ( search.hasClass('_focused') ) {
            search.removeClass('_focused');
            mControls.removeClass('_z-index');
        }
    });

    $(document).on("mouseup touchend", function(e){
        if (!search.is(e.target) && search.has(e.target).length === 0) {
            search.removeClass('_focused');
            mControls.removeClass('_z-index');
        }
    });

}
